module.exports = __webpack_public_path__ + "img/know-yourself2.1653b411.png";